import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Typography from '@material-ui/core/Typography';
import { Helmet } from "react-helmet";

import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles(theme => ({
    heroTitle: {
        fontSize: "6rem",
        color: theme.palette.common.black,
        lineHeight: 1,
        [theme.breakpoints.down("md")]: {
            fontSize: "5.5rem",
        },
        [theme.breakpoints.down("sm")]: {
            fontSize: "4.5rem",
        },
        [theme.breakpoints.down("xs")]: {
            fontSize: "3.5rem",
        },
    },

    heroSubtitle: {
        fontSize: "4rem",
        color: theme.palette.common.black,
        lineHeight: 1,
        [theme.breakpoints.down("md")]: {
            fontSize: "3.5rem",
        },
        [theme.breakpoints.down("sm")]: {
            fontSize: "3rem",
        },
        [theme.breakpoints.down("xs")]: {
            fontSize: "1.7rem",
        },
    },
}))

export default function Notfound(props) {
    const classes = useStyles();

    return (
        <React.Fragment>
            <Helmet>
                <title>Notfound - Techno, Construction LLC</title>
            </Helmet>

            <Grid container direction="column" alignItems="center" justify="center" style={{ marginTop: 100, marginBottom: 100, }}>
                <Grid item>
                    <Typography variant="h1" className={classes.heroTitle} paragraph>
                        404 ERROR
                </Typography>
                </Grid>
                <Grid item>
                    <Typography variant="h1" className={classes.heroSubtitle} paragraph>
                        Sorry, the page not found
                    </Typography>
                </Grid>
                <Grid item>
                    <Typography variant="subtitle1" className={classes.heroSubtitle}>
                        Back to Home
                    </Typography>
                </Grid>

            </Grid>
        </React.Fragment>
    )
}